"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryRadio = void 0;
const react_1 = __importStar(require("react"));
const common_1 = require("../../../../common");
const react_i18next_1 = require("react-i18next");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const STATE_CHECKBOX_LIST = [
    { id: 'lesson', title: 'supportRoom.lesson', checked: false },
    { id: 'subject', title: 'supportRoom.subject', checked: false },
    { id: 'textbook', title: 'supportRoom.textbook', checked: false },
    { id: 'attendance', title: 'supportRoom.attendance', checked: false },
    { id: 'preview', title: 'supportRoom.preview', checked: false },
    { id: 'system', title: 'supportRoom.system', checked: false },
    { id: 'gmk', title: 'supportRoom.gmk', checked: false },
    { id: 'etc', title: 'supportRoom.etc', checked: false },
];
const STATE_DROPDOWN_LIST = [
    { id: 'select', title: 'common.select' },
    { id: 'lesson', title: 'supportRoom.lesson' },
    { id: 'subject', title: 'supportRoom.subject' },
    { id: 'textbook', title: 'supportRoom.textbook' },
    { id: 'attendance', title: 'supportRoom.attendance' },
    { id: 'preview', title: 'supportRoom.preview' },
    { id: 'system', title: 'supportRoom.system' },
    { id: 'gmk', title: 'supportRoom.gmk' },
    { id: 'etc', title: 'supportRoom.etc' },
];
const LOCK_CHECKBOX = {
    id: 'type',
    title: 'supportRoom.lockSetting',
    checked: false,
};
exports.CategoryRadio = react_1.default.memo(({ defaultCategory, setCategory, defaultPrivate, setPrivate }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [list, setList] = (0, react_1.useState)(STATE_CHECKBOX_LIST);
    const [state, setState] = (0, react_1.useState)(STATE_DROPDOWN_LIST[0]);
    const [lock, setLock] = (0, react_1.useState)(LOCK_CHECKBOX);
    (0, react_1.useEffect)(() => {
        const updatedList = list.map(item => item.id === defaultCategory
            ? { ...item, checked: true }
            : { ...item, checked: false });
        const updateState = STATE_DROPDOWN_LIST.filter(item => item.id === defaultCategory);
        isMobile
            ? setState(updateState.length === 0 ? STATE_DROPDOWN_LIST[0] : updateState[0])
            : setList(updatedList);
    }, [defaultCategory]);
    (0, react_1.useEffect)(() => {
        setLock(prevLock => ({ ...prevLock, checked: defaultPrivate }));
    }, [defaultPrivate]);
    (0, react_1.useEffect)(() => {
        const checkedItem = isMobile ? state : list.find(item => item.checked);
        if (checkedItem) {
            setCategory(checkedItem.id);
        }
    }, [list, state, setCategory]);
    (0, react_1.useEffect)(() => {
        setPrivate(lock.checked);
    }, [lock.checked, setPrivate]);
    const handlerCheckRadio = (0, react_1.useCallback)((id) => {
        setList(prevList => prevList.map(item => item.id === id ? { ...item, checked: true } : { ...item, checked: false }));
    }, []);
    const handlerCheck = (0, react_1.useCallback)(() => {
        setLock(prevLock => ({ ...prevLock, checked: !prevLock.checked }));
    }, []);
    const renderCheckBox = (0, react_1.useMemo)(() => (react_1.default.createElement(common_1.CheckBoxElement, { key: lock.id, ...lock, handlerCheck: handlerCheck, style: { paddingTop: '2px' } })), [lock, handlerCheck]);
    return (react_1.default.createElement("div", { className: "field-global-001", style: { flexDirection: isMobile ? 'column' : 'row' } },
        react_1.default.createElement("div", { className: "field-short", style: {
                alignItems: isMobile ? 'center' : 'flex-start',
            } },
            react_1.default.createElement("div", { className: "task-label" }, t('supportRoom.category')),
            isMobile ? (react_1.default.createElement("div", { style: {
                    width: '100%',
                    gap: '4px',
                    display: 'flex',
                    flexDirection: 'column',
                } },
                react_1.default.createElement(common_1.DropDown, { className: "dropdown-mobile-small", value: state, list: STATE_DROPDOWN_LIST, setDropValue: setState }))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(common_1.CheckBox, { isRadioButton: true, list: list, handlerCheck: handlerCheckRadio }),
                react_1.default.createElement("div", { style: {
                        background: 'var(--color-grey-c, #e6e8ed)',
                        width: '1px',
                        height: '28px',
                    } }),
                renderCheckBox))),
        isMobile && react_1.default.createElement("div", { style: { alignSelf: 'start' } }, renderCheckBox)));
});
